<template>
  <div class="portrait-video-controller-parts">
    <!-- 30s 巻き戻し -->
    <button
      class="portrait-video-controller-parts__button portrait-video-controller-parts__button__prev30s"
      @click="prevVideo30s"
    >
      <img :src="require('@/assets/img/icon/video_controller_prev30s.svg')" alt="" />
    </button>

    <!-- 再生 -->
    <button
      v-if="videoPausedStatus"
      class="portrait-video-controller-parts__button portrait-video-controller-parts__button__play"
      @click="playVideo"
    >
      <img :src="require('@/assets/img/icon/video_controller_play.svg')" alt="" />
    </button>

    <!-- 一時停止 -->
    <button
      v-if="!videoPausedStatus"
      class="portrait-video-controller-parts__button portrait-video-controller-parts__button__pause"
      @click="pauseVideo"
    >
      <img :src="require('@/assets/img/icon/video_controller_pause.svg')" alt="" />
    </button>

    <!-- 30秒 先送り -->
    <button
      class="portrait-video-controller-parts__button portrait-video-controller-parts__button__next30s"
      @click="nextVideo30s"
    >
      <img :src="require('@/assets/img/icon/video_controller_next30s.svg')" alt="" />
    </button>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面 動画プレーヤー 縦画面 動画コントローラー コンポーネント
 */
export default defineComponent({
  name: 'PortraitVideoControllerParts',
  props: {
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * ビデオ一時停止フラグ
     */
    videoPaused: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const screenLandScape = computed(() => props.screenOrientationType?.indexOf('landscape') !== -1)
    const videoPausedStatus = computed(() => props.videoPaused)

    return {
      screenLandScape,
      videoPausedStatus,
    }
  },
  methods: {
    playVideo(): void {
      /**
       * ビデオ 再生 処理
       */
      this.$emit('videoPlayPauseChange', false)
    },
    pauseVideo(): void {
      /**
       * ビデオ 一時停止 処理
       */
      this.$emit('videoPlayPauseChange', true)
    },
    prevVideo30s(): void {
      /**
       * ビデオ 30秒巻き戻し 処理
       */
      this.$emit('videoPlayChangeCurrentTime', -30.0)
    },
    nextVideo30s(): void {
      /**
       * ビデオ 30秒先送り 処理
       */
      this.$emit('videoPlayChangeCurrentTime', 30.0)
    },
  },
})
</script>

<style lang="scss" scoped>
.portrait-video-controller-parts {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;

    img {
      width: 24px;
      height: 24px;
    }

    &__play,
    &__pause {
      margin: 0 64px;

      img {
        width: 32px;
        height: 32px;
        opacity: 0.7;
      }
    }
  }
}
</style>
